import { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { StatusCodes } from 'http-status-codes';
import {
  FnbOrderGetDto,
  OrderGetMinDTO,
  ProductGetDTO,
  QuantityGetDto,
  WarehouseLocationGetDTO,
} from 'svila-common';

import WhitePad from '../../../../../components/common/WhitePad/WhitePad';
import SecondaryNavigation from '../../../../../components/common/navigation/SecondaryNavigation';
import TitleComponent from '../../../../../components/common/forms/Title/TitleComponent';
import PalletDescription from './components/PalletDescription';
import { PalletGetDTO } from 'svila-common/types/back-end/palletGetDTO';
import PalletDescriptionsApi from '~/src/services/api/PalletDescriptionsApi';
import Loader from '~/src/components/common/Loader';
import { CustomerGetMinDTO } from 'svila-common/types/back-end/customerGetMinDTO';
import { ContainerGetDTO } from 'svila-common/types/back-end/containerGetDTO';
import printerIcon from '../../../../../static/img/printerIcon.svg';
import { WarehouseGetDto } from 'svila-common/types/back-end/warehouseGetDTO';
export interface PalletDescriptionEditDto {
  name: string;
  sortOrderNumber: number;
  orderId: string;
  locationId: string;
  palletId: string;
  isRemoved: boolean;
  warehouseId: string;
}
export interface PalletDescriptionGetDto {
  id: string;
  name: string;
  sortOrderNumber: number;
  orderId: string;
  order: OrderGetMinDTO;
  locationId: string;
  location: WarehouseLocationGetDTO;
  palletId: string;
  pallet: PalletGetDTO;
  isRemoved: boolean;
  warehouseId: string;
  warehouse: WarehouseGetDto;
}

export interface WarehouseLocationEditDTO {
  chamberNumber: number;
  column: number;
  letter: string;
  level: number;
}
export interface PalletDescriptionWithOrder {
  order: OrderWithoutProductsDto;
  palletData: LocationWithQuantitiesDto[];
}
export interface LocationWithQuantitiesDto {
  location: WarehouseLocationEditDTO;
  groupedQuantities: GroupedQuantitiesByProduct[];
  palletDescriptionObject: PalletDescriptionGetDto;
}

export interface GroupedQuantitiesByProduct {
  product: ProductGetDTO;
  quantities: QuantityGetDto[];
}

export interface OrderWithoutProductsDto {
  id: string;
  orderNumber: number;
  customer: CustomerGetMinDTO;
  customerId: string;
  pallet: PalletGetDTO;
  palletId: string;
  palletMaxWidth: number;
  palletMaxHeight: number;
  palletMaxLength: number;
  maxKg: number;
  shippingType: string;
  orderProducts: IOrderProduct[];
  container: ContainerGetDTO;
  containerId: string;
  destination: string;
  containerLine: string;
  vesselFlag: string;
  containerNo: string;
  truckTrailer: string;
  routing: string;
  orderType: string;
  fnbOrder: FnbOrderGetDto;
  consolidationParentOrderId: string;
  isConsolidation: boolean;
}

export default function PalletDescriptions(): JSX.Element {
  const { id, consolidation } = useParams();
  const [itemData, setItemData] = useState<PalletDescriptionWithOrder>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [loadingError, setLoadingError] = useState<string | null>(null);
  const history = useHistory();

  const getItem = async (): Promise<void> => {
    setLoading(true);
    const result = await PalletDescriptionsApi.getPalleDescription(id, true);
    if (result.status === StatusCodes.OK) {
      setItemData(result.data);
    } else {
      setLoadingError('Error loading data');
    }
    setLoading(false);
  };

  useEffect(() => {
    getItem();
  }, []);

  return (
    <WhitePad isFluid>
      <SecondaryNavigation isConsolidation={consolidation} />

      <TitleComponent
        title="Pallets"
        titleRight="Print/PDF"
        onRightHandler={() => {
          window.open(`/orders/pallet-description/print/${id}`, '_blank');
        }}
        onLeftHandler={(): void => {
          history.push('/orders-list');
        }}
        iconRight={printerIcon}
      />

      <p>{itemData?.order?.customer?.name}</p>
      <p>{itemData?.order?.orderNumber}</p>

      {loading ? (
        <Loader />
      ) : loadingError ? (
        <div>{loadingError}</div>
      ) : itemData?.palletData?.length === 0 ? (
        <div>No data</div>
      ) : (
        <div>
          {itemData?.palletData?.map((locationWithQuantities, index: number) => {
            return <PalletDescription key={index} item={locationWithQuantities} index={index} />;
          })}
        </div>
      )}
    </WhitePad>
  );
}
